import { DropdownDetailsIcon } from "../../lead-inventory/icons";

import { useState, useEffect } from "react";

const AssignedTableAction = ({ leadId, onAssignFarmer }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    let timer;
    if (isOpen) {
      timer = setTimeout(() => setIsOpen(false), 3000);
    }
    return () => clearTimeout(timer);
  }, [isOpen]);

  return (
    <div className="relative">
      <button
        type="button"
        className="bg-transparent"
        onClick={() => setIsOpen((v) => !v)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
          />
        </svg>
      </button>

      <div
        className={`absolute right-0 z-10 py-1 bg-white shadow-lg backdrop-blur-sm rounded-lg 
          ${isOpen ? "visible opacity-100" : "invisible opacity-0"}
          transition-all duration-200 min-w-[200px] mt-2`}
        role="menu"
      >
        <a
          href={`/account_details?lead_id=${leadId}`}
          className="flex items-center px-4 py-2 text-sm text-[#1E293B] hover:bg-[#F1F5F9]"
          role="menuitem"
        >
          <img
            src={DropdownDetailsIcon}
            alt="Details"
            className="w-5 h-5 mr-2"
          />
          View Full Details
        </a>

        <button
          type="button"
          onClick={() => {
            setIsOpen(false);
            onAssignFarmer?.(leadId);
          }}
          className="flex items-center w-full px-4 py-2 text-sm text-left text-[#1E293B] hover:bg-[#F1F5F9]"
          role="menuitem"
        >
          <span className="w-5 h-5 mr-2 flex items-center justify-center">
            🧑‍🌾
          </span>
          Assign Farmer
        </button>
      </div>
    </div>
  );
};

export default AssignedTableAction;
